import React from "react";
import ReactMarkdown from "react-markdown";
import RemarkGFM from "remark-gfm";
import RemarkMath from "remark-math";
import RehypeKatex from "rehype-katex";
import "katex/dist/katex.min.css";

const MarkdownViewer = (props) => {
    const source = props.cell['source'];
    // '$$' has to be in a separate new line to be rendered as a block math equation.
    const re = /\n?\s*\$\$\s*\n?/g;
    const newSource = !source ? '' : source.join('').replaceAll(re, "\n$$$\n")
    const htmlContent = (
      <div className="cell-content source-markdown">
        <ReactMarkdown
          rehypePlugins={[RehypeKatex]}
          remarkPlugins={[RemarkGFM, RemarkMath]}
        >
          {newSource}
        </ReactMarkdown>
      </div>
    )
    return (
        <div className="cell-row">
          <pre className="cell-header source">{null}</pre>
          {htmlContent}
        </div>
    )
}

export default MarkdownViewer;